
// initial state
const state = {
  googleMapKey: 'AIzaSyC_ezKCQYLCjEWjWpjkatnUGZDcLw667dI',
  screenWidth: document.body.clientWidth,

}

// getters
const getters = {

}

// actions
const actions = {

}


// mutations
const mutations = {

    setScreenWidth (state, data)
    {
        state.screenWidth = data
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
